import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fgbcl-card-link-earn-steps',
  templateUrl: './card-link-earn-steps.component.html',
  styleUrls: ['./card-link-earn-steps.component.scss'],
})
export class CardLinkEarnStepsComponent implements OnInit {
  constructor() {}
  @Input() cardTitle: string = '';

  @Input() stepOneText: string = '';
  @Input() stepTwoText: string = '';
  @Input() stepThreeText: string = '';

  @Input() stepOneSmallPrintText: string = '';
  @Input() stepTwoSmallPrintText: string = '';
  @Input() stepThreeSmallPrintText: string = '';

  @Input() stepOneIcon: string = '';
  @Input() stepTwoIcon: string = '';
  @Input() stepThreeIcon: string = '';

  @Input() horizontalLine: boolean = true;
  @Input() filled: boolean = true;
  @Input() border: boolean = false;

  ngOnInit(): void {}
}
